import React from "react";
import Aux from "../../../../hoc/Aux/Aux";
import "./Button.css";
import { prefix } from "../../../../scripts/helpers/constants";

const button = props => {
  return (
    <Aux>
      <a
        target="_blank"
        href={props.reference}
        className={prefix + "-c-button-main"}
      >
        <button className="button-school">{props.children}</button>
      </a>
    </Aux>
  );
};

export default button;



// WEBPACK FOOTER //
// ./src/components/SchoolBand/School/Button/Button.js